import type { ListControlProps } from '../../declare'
import { useState, useEffect, useContext } from 'react'
import { autorun } from 'mobx'
import { Select } from 'antd'
import { ListSearchContext } from 'src/components'
import { appStore } from 'src/stores'

const EnumSelect = (props: ListControlProps) => {
  const search = useContext(ListSearchContext)

  const handleChange = (value: any) => {
    props.onChange?.(value)
  }

  const [options, setOptions] = useState([])
  useEffect(() => autorun(() => {
    const find = search.searchConfig?.Nav_Enums?.find((item: any) => item.EnumName === props.config.ENUM_NAME)
    if (find?.options) {
      setOptions(find.options)
    } else {
      appStore.getEnums([props.config.ENUM_NAME]).then((data: any[]) => {
        setOptions(appStore.getEnumOptions(props.config.ENUM_NAME, data))
      })
    }
  }), [props.config.ENUM_NAME])

  const { PROMPT_INFO } = props.config
  return (
    <Select
      allowClear
      value={props.value !== undefined ? Number(props.value) : props.value}
      options={options}
      onChange={handleChange}
      placeholder={PROMPT_INFO}
      style={{ width: 183 }}
    />
  )
}

export default EnumSelect